import dayjs from 'dayjs'

export function formatDate (timestamp, withTime = true) {
  let formatStr = 'YYYY-MM-DD'
  if (withTime) {
    formatStr += ' HH:mm:ss'
  }
  return timestamp ? dayjs(timestamp).format(formatStr) : timestamp
}
